import { useLingui } from '@lingui/react';

import { Stepper, StepperProps } from '@/design_system/Stepper/Stepper';
import { ARTICLE_DISPLAYED_STEPS, getDisplayedStep } from '@/models/article';
import { ArticleWithRelations } from '@/models/request';

import { getFilteredStepsForClientStepper } from './ClientStepper/utils';

export const ClientArticleStepper = ({
  article,
  ...props
}: {
  article: ArticleWithRelations;
} & Omit<StepperProps, 'steps'>) => {
  const { _ } = useLingui();

  if (!article.steps) {
    return '-';
  }

  const steps = article.steps
    .map((step) => {
      const displayedStep = getDisplayedStep(step);

      if (!displayedStep || displayedStep === 'completed') {
        return null;
      }

      return {
        ...step,
        name: _(ARTICLE_DISPLAYED_STEPS.find(({ id }) => id === displayedStep)!.name),
      };
    })
    .filter((step) => !!step);

  const filteredSteps = getFilteredStepsForClientStepper(steps);

  if (!filteredSteps.length) {
    return '-';
  }

  return <Stepper steps={filteredSteps} {...props} />;
};
